import React, { createContext, useContext, ReactNode } from 'react';

interface RootContextType {
  rootElement: HTMLElement | ShadowRoot | null;
}

const RootContext = createContext<RootContextType | null>(null);

interface RootProviderProps {
  rootElement: HTMLElement | ShadowRoot | null;
  children: ReactNode;
}

export const RootProvider: React.FC<RootProviderProps> = ({ rootElement, children }) => {
  const contextValue: RootContextType = {
    rootElement
  };

  return (
    <RootContext.Provider value={contextValue}>
      {children}
    </RootContext.Provider>
  );
};

export const useRootContext = () => {
  const context = useContext(RootContext);
  if (!context) {
    throw new Error('useRootContext must be used within a RootProvider');
  }
  return context;
};

// Convenience hook to get just the root element
export const useRootElement = () => {
  const { rootElement } = useRootContext();
  return rootElement;
};

// Safe version that returns null instead of throwing when outside RootProvider
export const useSafeRootElement = (): HTMLElement | ShadowRoot | null => {
  const context = useContext(RootContext);
  return context?.rootElement ?? null;
};